import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { isDeployingSelector } from '../../socketServer'

export function useIsDeploying() {
  return useSelector<RootState, boolean>(isDeployingSelector)
}
